import React from "react"
import types from "prop-types"
import Select from "./Select"

// Values must match access levels in AccessLevelable
const OPTIONS = [
  { label: "Super", value: "super_access" },
  { label: "Standard", value: "standard_access" },
  { label: "None", value: "none_access" },
]

const AccessLevelSelect = ({
  onChange,
  value = null,
  isDisabled = false,
  selectLabel = "select access level",
  optionsToOmit = [],
}) => {
  const options = OPTIONS.filter((option) => !optionsToOmit.includes(option.value))

  return (
    <Select
      className="min-w-[7.5rem] shrink-0"
      backspaceDelete={false}
      onChange={onChange}
      options={options}
      required
      disabled={isDisabled}
      value={value}
      label={selectLabel}
    />
  )
}

AccessLevelSelect.propTypes = {
  onChange: types.func.isRequired,
  value: types.string,
  selectLabel: types.string,
  isDisabled: types.bool,
  optionsToOmit: types.array,
}

export default AccessLevelSelect
